export const UPLOAD_START = 'app/store/upload/UPLOAD_START';
export const UPLOAD_STOP = 'app/store/upload/UPLOAD_STOP';
